module.exports = __webpack_public_path__ + "static/media/0304_Small.90b35286.jpg";